import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {Field} from "../interfaces/field";
import {InputTextModule} from "primeng/inputtext";
import {DropdownModule} from "primeng/dropdown";
import {TooltipModule} from "primeng/tooltip";
import {CardModule} from "primeng/card";
import {MultiSelectModule} from "primeng/multiselect";
import {ListboxModule} from "primeng/listbox";
import {TagModule} from "primeng/tag";


@Component({
    selector: 'rq-form-field',
    templateUrl: './rq-form-field.component.html',
    imports: [CommonModule, ReactiveFormsModule, InputTextModule, DropdownModule, TooltipModule, FormsModule, CardModule, MultiSelectModule, ListboxModule, TagModule],
    standalone: true
})
export class RqFormFieldComponent implements OnInit {
    @Input() field!: Field<string>;
    @Input() form!: FormGroup;
    datosCargados: boolean = false

    ngOnInit(): void {
        console.log(`ngOnInit ->${this.constructor.name}`);
    }

    get isValid() {
        return this.form.controls[this.field.key].valid;
    }
}
